import { Component } from "react";
import "react-datetime/css/react-datetime.css";
import {
  Appointment as IAppointment,
  Checklist,
  Email,
} from "../modals/Appointment";
import { format, addDays } from "date-fns";
import BookingCalendar from "./BookingCalendar/BookingCalendar";
import { IBodyshopService } from "../UserService";
import moment, { Moment } from "moment";
import DisplayBooking from "./DisplayBooking/DisplayBooking";
import { Message } from "semantic-ui-react";
import MessageDialog from "../Message/Message";
import { deleteBookingTask } from "../Services/TaskService";
import PickUp from "./PickUp/PickUp";
import { screens } from "../modals/Enums/Screens";
import { Button, Grid, GridItem, Alert, AlertIcon } from "@chakra-ui/react";
import _ from "lodash";
import APIService from "../Services/APIService";
import CancelBooking from "./CancelBooking/CancelBooking";
import {
  JobEstimationDetail,
  IQACustomDetails,
} from "../modals/JobEstimationDetail";
import { IBSAdonisService } from "../Services/IBSAdonisService";
import { BookingState } from "../modals/StateInterface/BookingState";
import { Mixpanel } from "../Services/MixPanel";
import { CommonMethodService } from "../Services/CommonMethodService";
import {
  BookingAllowance,
  BudgetCategoryValue,
  IBookingDay,
} from "../modals/BookingAllowance";
import BookingConfirmed from "./BookingConfirmed/BookingConfirmed";
import { BookingProps } from "../CommonProps";
import "./Booking.css";

export default class Booking extends Component<BookingProps, BookingState> {
  repairCalendarId: string = "4e4e14c7-45c7-4f54-8724-2a30aac8e61d";
  private iBodyShopService = new IBodyshopService();
  private apiService = new APIService();
  private ibsAdonisService = new IBSAdonisService();
  private commonMethodService = new CommonMethodService();

  appointments: IAppointment[] = [];
  appointmentsDates: IAppointment[] = [];
  budgetRevisions: any = {};
  ArrivalsJobs: any = {};
  allData: any[] = [];
  selectedDayData: any = {};
  selectedAppointment: IAppointment | null = null;
  selectedChecklist: Checklist | null = null;
  defaultSMS: string = "2d86f2dd-c7ea-4f6a-85a2-4968140f588a"; // confirm message template
  defaultEmail: string = "40f154f5-4321-4fa9-8815-6e31d4ba6f26"; // confirm email template

  constructor(props: BookingProps) {
    super(props);
    this.state = {
      customQADetails: null,
      showDetails: false,
      data: format(new Date(), "ccc dd MMM yy"),
      estimateDetails: props.estimateDetails,
      appointments: [],
      allAppointments: [],
      showLoader: true,
      step: 1,
      bookingDate: null,
      bookingSlot: null,
      isBooked: !!props.estimateDetails?.expectedArrival,
      bookingSuccessful: false,
      showConfirmation: false,
      slots: [],
      isRevised: false,
      isVehicleOnSite: !props.estimateDetails.isVehicleOnSite,
      showConfirmationOfCancelBooking: false,
      bookingCancel: false,
      canceledReason: "",
      bookingDateError: "",
      bookingMessage: null,
      bookingAllowance: {
        estimatedArrivalStartInterval: 0,
        estimatedCompletion: 0,
        estimatedCompletionCollectionInterval: 0,
      },
      bookingDropoffRange: null,
    };
    this.getCustomQAFields(props.estimateDetails.estimateId);
    this.getPredictedWorkTime();
    this.getBookingDropoffRange();
  }

  async getBookingDropoffRange() {
    try {
      const res = await this.apiService.getBookingDropoffRange();
      if (res.ok) {
        const data = await res.json();
        this.setState({ bookingDropoffRange: data });
      } else {
        console.error("Failed to fetch booking drop-off range data");
      }
    } catch (error) {
      console.error("Error fetching booking drop-off range data", error);
    }
  }

  private getFutureWeekdayDate(startDate: Date, daysToAdd: number) {
    let futureDate = new Date(startDate);
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      futureDate = addDays(futureDate, 1);
      const dayOfWeek = futureDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }

    return futureDate;
  }
  async getAppointments() {
    this.setState({
      appointments: [],
      allAppointments: [],
    });
    try {
      const value = (this.state as any)?.customQADetails?.values.find(
        (val: { value: number | boolean }) => typeof val.value === "number"
      )?.value;
      const daysToAdd = Number(value);
      const futureDate = this.getFutureWeekdayDate(new Date(), daysToAdd);
      const formattedDate = format(futureDate, "ccc dd MMM yy");
      const dateRange: { start: string; end: string } =
        this.getNextThreeMonthsRange(new Date(formattedDate));
      await this.apiService.getBookingDays(dateRange).then(async (res) => {
        if (res.ok) {
          const data = await res.json();
          this.allData = data.data;
          const appointments = await this.checkAppointment(
            this.allData,
            new Date(this.state.data)
          );
          if (appointments && appointments.length <= 0) {
            Mixpanel.track("Get Appointment Empty", {
              status: "Data not fetched",
            });
          }
          this.appointments = appointments;

          this.setState({
            allAppointments: appointments,
            appointments: appointments,
            showLoader: false,
          });
          Mixpanel.track("Get Appointment", {
            data,
            status: "Data fetched",
          });
        } else {
          this.setState({
            allAppointments: [],
            appointments: [],
            showLoader: false,
          });
          Mixpanel.track("Get Appointment", {
            error: res,
            status: res?.status,
          });
        }
      });
    } catch (ex) {
      this.setState({
        allAppointments: [],
        appointments: [],
        showLoader: false,
      });
      Mixpanel.track("Get Appointment", {
        error: ex,
        status: "Something went wrong",
      });
    }
  }

  async getBudgetRevisions() {
    await this.apiService.getBudgetRevisions().then(async (res) => {
      if (res.ok) {
        const data = await res.json();
        this.budgetRevisions = data.data.find(
          (budgetRevision: any) => !!budgetRevision.isCurrent
        );
      }
    });
  }
  async getArrivalDisplayJobs() {
    await this.apiService.getArrivalDisplayJobs().then(async (res) => {
      if (res.ok) {
        const data = await res.json();
        this.ArrivalsJobs = data;
      }
    });
  }
  getNextThreeMonthsRange(startDate: Date): { start: string; end: string } {
    const today = startDate;
    const start = `${today.getFullYear()}-${(today.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
    const endMonth = new Date(today.getFullYear(), today.getMonth() + 3, 0); // 0 gets the last day of the previous month
    const end = `${endMonth.getFullYear()}-${(endMonth.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${endMonth.getDate().toString().padStart(2, "0")}`;

    return { start, end };
  }

  async getPredictedWorkTime() {
    try {
      // Fetch estimated repair days from IBS service
      const estimatePlanningResult =
        await this.ibsAdonisService.getEstimatePlanning(
          this.props.estimateDetails.estimateId
        );

      this.setState({
        bookingAllowance: {
          estimatedCompletion:
            estimatePlanningResult?.suggestedRepairDaysRequired,
          estimatedArrivalStartInterval: 3, // Default or fetch from data
          estimatedCompletionCollectionInterval: 3, // Default or fetch from data
        },
      });
      // Fetch booking allowance from the API service
      const bookingAllowanceResponse =
        await this.apiService.getBookingAllowance();

      if (bookingAllowanceResponse.ok) {
        const bookingAllowanceData = await bookingAllowanceResponse.json();

        if (bookingAllowanceData && bookingAllowanceData.data.length > 0) {
          const bookingAllowance: BookingAllowance =
            bookingAllowanceData.data[0];

          // Update state with adjusted values based on conditions
          this.setState({
            bookingAllowance: {
              estimatedCompletion:
                estimatePlanningResult.suggestedRepairDaysRequired > 0
                  ? estimatePlanningResult.suggestedRepairDaysRequired
                  : bookingAllowance?.estimatedCompletion || 5,
              estimatedArrivalStartInterval:
                bookingAllowance?.estimatedArrivalStartInterval > 0
                  ? bookingAllowance.estimatedArrivalStartInterval
                  : 3,
              estimatedCompletionCollectionInterval:
                bookingAllowance?.estimatedCompletionCollectionInterval > 0
                  ? bookingAllowance.estimatedCompletionCollectionInterval
                  : 3,
            },
          });
        }
      }
    } catch (error) {
      Mixpanel.track("Get PredictedWorkTime Error", {
        error,
        status: "Something went wrong",
      });
    }
  }

  async fetchLockedDates(
    startDate: string,
    endDate: string
  ): Promise<string[]> {
    let lockedDates: string[] = [];
    try {
      const response = await this.apiService.getLockedDates(startDate, endDate);
      if (response.isSuccess) {
        lockedDates = response.data.map((item: any) =>
          moment(item.booking_date).format("YYYY-MM-DD")
        );
      } else {
        console.warn("Locked dates API returned a non-success response.");
      }
    } catch (error) {
      console.error("Error fetching locked dates:", error);
    }
    return lockedDates;
  }

  async checkAppointment(
    appointments: IAppointment[],
    date: Date
  ): Promise<IAppointment[]> {
    let availableAppointments: any[] = [];
    const dateRange = this.getNextThreeMonthsRange(date);

    const { start: startDate, end: endDate } = dateRange;
    const startDateDiff = moment(startDate);
    const endDateDiff = moment(endDate);

    // Calculate the difference in days
    const differenceInDays = endDateDiff.diff(startDateDiff, "days");
    const lockedDates = await this.fetchLockedDates(startDate, endDate);

    const currentWorkTypeBudget = Array.isArray(
      this.budgetRevisions.categoryValues
    )
      ? this.budgetRevisions.categoryValues?.find(
          (budgetRevision: BudgetCategoryValue) =>
            budgetRevision.name === this.state.estimateDetails.workType
        )
      : {};
    const currentDate = moment();
    for (let i = 0; i <= differenceInDays; i++) {
      const dueDate = currentDate.add(1, "days").format("YYYY-MM-DD");
      const dueDay = moment(dueDate).format("dddd");
      const budget =
        currentWorkTypeBudget?.valueSeries[dueDay.toLowerCase()] || 0;
      let availableBudget = 0;
      if (lockedDates.includes(dueDate)) {
        availableBudget = 0;
      } else {
        const selectedDateAppointments = this.ArrivalsJobs.filter(
          (appointment: any) =>
            moment(appointment.estimatedArrival).format("YYYY-MM-DD") ===
              dueDate &&
            appointment.workType === this.state.estimateDetails.workType
        );

        if (selectedDateAppointments.length > 0) {
          availableBudget = budget - selectedDateAppointments.length;
        } else {
          availableBudget = budget;
        }
      }

      availableAppointments.push({
        dueDate: dueDate,
        budget: availableBudget > 0 ? availableBudget : 0,
      });
    }

    availableAppointments = _.uniqBy(availableAppointments, "dueDate");

    return availableAppointments;
  }

  onDateSelected = (date: Moment) => {
    if (date && this.state.estimateDetails) {
      this.setState({ bookingDateError: "" });
      this.selectedAppointment =
        this.state.appointments.find((x: any) => {
          return (
            moment(x.dueDate).format("YYYY-MM-DD") === date.format("YYYY-MM-DD")
          );
        }) ?? null;

      this.selectedDayData = this.allData.find((data: any) => {
        return moment(data.date).isSame(date, "day");
      });

      const dropOffTimes = this.allData.find((slot: any) => {
        return slot.id === this.selectedAppointment?.booking_day_id;
      });

      let startTime = moment(
        this.state.bookingDropoffRange?.start_time,
        "HH:mm:ss"
      );
      let endTime = moment(
        this.state.bookingDropoffRange?.end_time,
        "HH:mm:ss"
      );

      if (endTime.isBefore(startTime)) {
        endTime = endTime.add(1, "day");
      }

      const timeSlots: string[] = [];
      while (startTime.isBefore(endTime) || startTime.isSame(endTime)) {
        timeSlots.push(startTime.format("hh:mm A"));
        startTime = startTime.add(30, "minutes");
      }

      let times: Array<{
        time: string;
        id: number | null;
        occupiedDropOff: boolean;
      }> = timeSlots.reduce(
        (
          acc: Array<{
            time: string;
            id: number | null;
            occupiedDropOff: boolean;
          }>,
          slot: string
        ) => {
          const existingDropOff = dropOffTimes?.bookingDayDropOffTime?.find(
            (dropOff: any) =>
              moment(slot, "hh:mm A").format("HH:mm:ss") === dropOff.drop_off
          );

          if (!existingDropOff) {
            acc.push({
              time: slot,
              id: null,
              occupiedDropOff: false,
            });
          }

          return acc;
        },
        []
      );
      this.setState({
        slots: times,
        bookingDate: date,
      });
    }

    Mixpanel.track("User Select Date", {
      date: moment(date).format("YYYY-MM-DD"),
      estimateDetail: this.state.estimateDetails,
    });
  };

  slotsCalculator = (startStr: any, endStr: any) => {
    var x = 60; // minutes interval
    var times = []; // time array
    var tt = startStr * 60; // start time
    var ee = endStr * 60;
    var ap = ["AM", "PM"]; // AM-PM

    //loop to increment the time and push results in array
    for (var i = 0; tt <= ee; i++) {
      var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      var mm = tt % 60; // getting minutes of the hour in 0-55 format
      times[i] = {
        time:
          ("0" + (hh % 12 === 0 ? 12 : hh % 12)).slice(-2) +
          ":" +
          ("0" + mm).slice(-2) +
          " " +
          ap[Math.floor(hh / 12)],
      }; // pushing data in array in [00:00 - 12:00 AM/PM format]
      tt = tt + x;
    }

    this.setState({
      slots: times,
    });
  };

  onSlotPicked = (slot: any) => {
    if (slot) {
      this.setState({
        bookingSlot: slot,
        bookingDateError: "",
      });
    }
    Mixpanel.track("User Select Slot", {
      slot: slot,
      estimateDetail: this.state.estimateDetails,
    });
  };

  saveBooking = async (revise?: boolean) => {
    // Start loader here
    this.setState({
      showLoader: true,
    });

    await this.booking();
    await this.updateChecklist(revise);

    await this.sendEmails();

    const message = `This estimate has been revised by the customer \nBooking Date: ${moment(
      this.state?.bookingDate
    ).format("ddd MMM D YYYY")}\nBooking Slot: ${
      this.state?.bookingSlot?.time
    }`;
    await this.sendNotification({
      isCancel: false,
      revise,
      reason: message,
      title: "Estimate Booking Revised",
    });

    await this.sendDefaultSMS();

    this.reloadEstimate();
    this.getPredictedWorkTime();
    this?.props?.handleBookingCompleted(true);
  };

  async booking() {
    let expectedArrival = "";
    if (this.state.bookingDate && moment(this.state.bookingDate).isValid()) {
      expectedArrival = this.getExpectedArrivalDate();
    }
    let expectedStart = this.commonMethodService.getPredictingWorkDate(
      expectedArrival,
      this.state.bookingAllowance.estimatedArrivalStartInterval
        ? this.state.bookingAllowance.estimatedArrivalStartInterval
        : 3
    ).date;
    let expectedEnd = this.commonMethodService.getPredictingWorkDate(
      expectedStart,
      this.state.bookingAllowance.estimatedCompletion
        ? this.state.bookingAllowance.estimatedCompletion
        : 5
    ).date;
    let expectedPickup = this.commonMethodService.getPredictingWorkDate(
      expectedEnd,
      this.state.bookingAllowance.estimatedCompletionCollectionInterval
        ? this.state.bookingAllowance.estimatedCompletionCollectionInterval
        : 3
    ).date;
    let date = new Date().toDateString();
    const bookingPayload = {
      aggregateRootId: this.state.estimateDetails.estimateId,
      expectedArrival,
      expectedStart,
      expectedEnd,
      expectedPickup,
      repairDaysRequired: this.state.estimateDetails?.jobBookingId
        ? this.state.estimateDetails?.repairDaysRequired
        : 0,
      bookingId: this.state.estimateDetails?.jobBookingId
        ? this.state.estimateDetails?.jobBookingId
        : null,
      jobId:
        this.state.estimateDetails.jobId ||
        "00000000-0000-0000-0000-000000000000",
      arrivalNotes: `The booking has been created from the customer portal on ${date}`,
    };
    await this.ibsAdonisService
      // await this.iBodyShopService
      .booking(bookingPayload)
      .then(async (res: any) => {
        if (res.ok) {
          res.json().then((resJSON: any) => {
            if (resJSON.IsSuccess) {
              this.setState({
                bookingSuccessful: true,
                bookingMessage: "Your booking details have been saved",
              });
              Mixpanel.track("Appointment Booked", {
                bookingObj: bookingPayload,
                estimateDetail: this.state.estimateDetails,
                status: "Appointment booked successfully",
              });
            } else {
              this.setState({
                bookingSuccessful: false,
                showLoader: false,
                bookingMessage:
                  "Your booking details have not been saved, Please try again.",
              });
              Mixpanel.track("Appointment Booked Error", {
                bookingObj: bookingPayload,
                error: resJSON,
                estimateDetail: this.state.estimateDetails,
                status: "Appointment not booked",
              });
              this.reloadEstimate();
              return;
            }
          });
        } else {
          const resp = await res.json();
          this.setState({
            bookingSuccessful: false,
            showLoader: false,
            bookingMessage:
              "Your booking details have not been saved, Please try again.",
          });
          Mixpanel.track("Appointment Booked Error", {
            bookingObj: bookingPayload,
            exceptionError: resp.Message,
            estimateDetail: this.state.estimateDetails,
            status: "Appointment not booked",
          });
          this.reloadEstimate();
          return;
        }
      })
      .catch((ex) => {
        this.setState({
          bookingSuccessful: false,
          showLoader: false,
          bookingMessage:
            "Your booking details have not been saved, Please try again.",
        });
        Mixpanel.track("Appointment Booked Error", {
          bookingObj: bookingPayload,
          exceptionError: ex,
          estimateDetail: this.state.estimateDetails,
          status: "Appointment not booked",
        });
        this.reloadEstimate();
        return;
      });
  }

  getExpectedArrivalDate() {
    const bookingDateMoment = moment(this.state.bookingDate);
    const bookingTimeMoment = moment(this.state.bookingSlot.time, "HH:mm");

    // Combine date and time
    const combinedDateTimeMoment = moment({
      year: bookingDateMoment.year(),
      month: bookingDateMoment.month(),
      date: bookingDateMoment.date(),
      hour: bookingTimeMoment.hour(),
      minute: bookingTimeMoment.minute(),
    });

    // Format the combined date and time
    return combinedDateTimeMoment.format("YYYY-MM-DDTHH:mm");
  }

  async updateChecklist(revise?: boolean) {
    if (this.selectedAppointment) {
      let bookingSlot = {
        bookingDayId: this.selectedAppointment.booking_day_id,
        bookingDayDropOffTimeId: this.state.bookingSlot.id,
        jobExternalId: this.state.estimateDetails.estimateId,
        slots: [
          {
            id: this.selectedAppointment.id,
          },
        ],
        confirmed: false,
      };

      let bookingSlotId: any;
      const res: any = await this.apiService.getBookingForId(
        this.state.estimateDetails.estimateId
      );
      await res.json().then((resJSON: any) => {
        if (resJSON.data && resJSON.data[0]) {
          bookingSlotId = resJSON.data[0].id;
        }
      });

      if (revise && bookingSlotId !== undefined) {
        const respBookedSlotUpdated = await this.apiService.bookSlotUpdate(
          bookingSlotId,
          bookingSlot
        );
        if (respBookedSlotUpdated.ok) {
          Mixpanel.track("Booking Slot Updated", {
            bookingSlotObj: bookingSlot,
            bookingSlotId: bookingSlotId,
            estimateDetail: this.state.estimateDetails,
            status: "Booking slot updated successfully",
          });
        } else {
          const resp = await respBookedSlotUpdated.json();
          Mixpanel.track("Booking Slot Updated Error", {
            bookingSlotObj: bookingSlot,
            bookingSlotId: bookingSlotId,
            error: resp.errors,
            estimateDetail: this.state.estimateDetails,
            status: "Booking slot not updated",
          });
        }
      } else {
      }
    }
  }

  async sendEmails() {
    try {
      const emailTemplates = await this.ibsAdonisService.getEmailTemplates(
        this.state.estimateDetails.estimateId.toString()
      );
      const selectedEmailTemplate = emailTemplates.find((template) => {
        return template.id === this.defaultEmail;
      });

      if (selectedEmailTemplate) {
        const emailTemplate: Email = {
          attachments: [],
          body: selectedEmailTemplate.message,
          fromName: "Flow Autobody",
          subject:
            "Booking is completed: " +
            this.state.estimateDetails.estimateNumber.toString(),
          to: [
            this.state.estimateDetails.email
              ? this.state.estimateDetails.email
              : "hello@flowautobody.com.au",
          ],
          assignedToId: this.state.estimateDetails.estimateId.toString(),
          jobNumber: this.state.estimateDetails.estimateNumber,
          bodyIsHtml: true,
          cc: ["hello@flowautobody.com.au"],
        };

        const responseOfSendEmail: any =
          await this.ibsAdonisService.sendEmailWithTemplate(emailTemplate);
        if (responseOfSendEmail.success) {
          Mixpanel.track("Customer Email Send", {
            emailTemplate: emailTemplate,
            estimateDetail: this.state.estimateDetails,
            status: "Email send successfully",
          });
        } else {
          Mixpanel.track("Customer Email Send Error", {
            emailTemplate: emailTemplate,
            estimateDetail: this.state.estimateDetails,
            error: responseOfSendEmail?.errors[0]?.message,
            status: "Email not send",
          });
        }
      } else {
        const emailBody =
          "Booking has been completed for Estimate: " +
          this.state.estimateDetails.estimateNumber.toString() +
          "<br/>Arrival: " +
          this.state.bookingDate?.format("DD/MMM/YYYY") +
          " at " +
          this.state.bookingSlot.time;
        const emailSubject =
          "Booking completed: " +
          this.state.estimateDetails.estimateNumber.toString();

        const responseOfSendEmail: any = await this.ibsAdonisService.sendEmail(
          emailBody,
          emailSubject,
          this.state.estimateDetails.estimateId.toString(),
          this.state.estimateDetails.estimateNumber.toString(),
          this.state.estimateDetails.email
            ? this.state.estimateDetails.email
            : "hello@flowautobody.com.au"
        );
        if (responseOfSendEmail?.success) {
          Mixpanel.track("Customer Email Send", {
            emailBody,
            emailSubject,
            estimateDetail: this.state.estimateDetails,
            status: "Email send successfully",
          });
        } else {
          Mixpanel.track("Customer Email Send Error", {
            emailBody,
            emailSubject,
            estimateDetail: this.state.estimateDetails,
            error: responseOfSendEmail?.errors[0]?.message || "",
            status: "Email not send",
          });
        }
      }
    } catch (error) {
      console.error("Unexpected error in sendEmails:", error);
    }
  }

  async sendNotification(data: {
    isCancel: boolean;
    revise?: boolean;
    reason?: string;
    title: string;
  }) {
    let expectedArrival = "";
    if (this.state.bookingDate && moment(this.state.bookingDate).isValid()) {
      expectedArrival = this.getExpectedArrivalDate();
    }
    let htmlContent = `<p>
    <strong ${
      data.isCancel
        ? `style='color:#FF0000'`
        : data.revise
        ? `style='color:#30824e'`
        : ``
    }>${
      data.isCancel
        ? "Canceled Job Booking"
        : data.revise
        ? "Revised Job Booking"
        : "Job Booking"
    }</strong> ${
      this.state.estimateDetails.estimateNumber
        ? this.state.estimateDetails.estimateNumber
        : ""
    }
    <br>
    <strong>Customer:</strong> ${
      this.state.estimateDetails?.ownerName
        ? this.state.estimateDetails?.ownerName
        : ""
    }
    <br>
    <strong>Email:</strong> ${
      this.state.estimateDetails?.email ? this.state.estimateDetails?.email : ""
    }
    <br>
    <strong>Contact:</strong> ${
      this.state.estimateDetails?.mobilePhone
        ? this.state.estimateDetails?.mobilePhone
        : ""
    }
    <br>
    ${
      data.isCancel
        ? ` <strong>Canceled Booking Date:</strong> ${moment(new Date()).format(
            "YYYY-MM-DD HH:mm A"
          )}`
        : ` <strong>Booking Date:</strong> ${expectedArrival}`
    }
    <br>
    ${
      !data.isCancel
        ? `<strong>Workflow:</strong> <a href="https://app.flowautobody.com/#/planner/booking-calendar">link</a> 
        <br>`
        : ""
    }

    <strong>IBS:</strong> <a href="https://app.ibodyshop.com/#/Estimate/${
      this.state.estimateDetails.estimateId
    }/header">link</a>
    <br>
    ${
      data.isCancel
        ? `<strong>Reason:</strong> ${this.state.canceledReason}`
        : ``
    }
  </p>`;
    const userEmail = this.state.estimateDetails?.email
      ? this.state.estimateDetails?.email
      : "";
    const response: any = await this.ibsAdonisService.sendTeamsNotification({
      message: htmlContent,
      email: userEmail,
      note: data.reason
        ? {
            message: data.reason,
            estimateId: this.state.estimateDetails.estimateId,
            title: data.title,
          }
        : undefined,
      estimateDetails: this.state.estimateDetails,
    });
    this.setState({ canceledReason: "" });
    if (response?.ok) {
      Mixpanel.track("Notification Send", {
        htmlContent: htmlContent,
        userEmail,
        bookingType: data.isCancel
          ? "Canceled Job Booking"
          : data.revise
          ? "Revised Job Booking"
          : "Job Booking",
        date: data.isCancel
          ? moment(new Date()).format("YYYY-MM-DD HH:mm A")
          : expectedArrival,
        estimateDetail: this.state.estimateDetails,
        status: "Notification send successfully",
      });
    } else {
      const resp = await response?.json();
      Mixpanel.track("Notification Send Error", {
        htmlContent,
        userEmail,
        bookingType: data.isCancel
          ? "Canceled Job Booking"
          : data.revise
          ? "Revised Job Booking"
          : "Job Booking",
        date: data.isCancel
          ? moment(new Date()).format("YYYY-MM-DD HH:mm A")
          : expectedArrival,
        estimateDetail: this.state.estimateDetails,
        error: resp,
        status: "Notification not send",
      });
    }
  }

  async sendDefaultSMS() {
    const defaultSMS = {
      estimateId: this.state.estimateDetails.estimateId,
      body: await this.getSMSTemplate(),
    };
    try {
      // Send the SMS
      const response: any = await this.ibsAdonisService.sendSMS(defaultSMS);
      // If the SMS is sent successfully, track it
      if (response?.success) {
        Mixpanel.track("Sms Send", {
          defaultSMS,
          estimateDetail: this.state.estimateDetails,
          status: "Sms send successfully",
        });
      } else {
        // Track the response if SMS was not sent successfully
        Mixpanel.track("Sms Send Error", {
          defaultSMS,
          estimateDetail: this.state.estimateDetails,
          error: response?.message || "Unknown error", // Using response message if available
          status: "Sms not send",
        });
      }
    } catch (error) {
      // Track the error in Mixpanel
      Mixpanel.track("Sms Send Error", {
        defaultSMS,
        estimateDetail: this.state.estimateDetails,
        error,
        status: "Sms not send",
      });
    }
  }

  getCustomQAFields(estimateId: string): void {
    this.ibsAdonisService
      .getCustomQADetails(estimateId)
      .then((res: IQACustomDetails[]) => {
        const customDetails = res as IQACustomDetails[];
        this.setState({
          customQADetails: customDetails[0],
        });
        this.getAppointments();
        this.getBudgetRevisions();
        this.getArrivalDisplayJobs();
      });
  }

  reloadEstimate() {
    // Reload estimate details here
    return this.ibsAdonisService
      .getJobEstimateDetailsById(
        this.state.estimateDetails.estimateNumber.toString()
      )
      .then((data: JobEstimationDetail) => {
        if (data) {
          this.setState({
            estimateDetails: data,
            isBooked: !!data?.expectedArrival,
            bookingSuccessful: false,
            step: 1,
            bookingDate: null,
            bookingSlot: null,
            isRevised: false,
            isVehicleOnSite: !data.isVehicleOnSite,
            slots: [],
            bookingDateError: "",
            bookingMessage: null,
            showLoader: false,
          });
          this.props.updateEstimateDetails(data);
        }
        this.selectedAppointment = null;
        this.selectedChecklist = null;
      });
  }

  reviseBooking = async () => {
    // Start loader here
    this.setState({
      showLoader: true,
    });
    const obj = {
      jobId: this.state.estimateDetails.estimateId,
      bookingId: this.state.estimateDetails.jobBookingId,
      expectedArrival: "",
      arrivalNotes: "",
      clearArrivalNotes: true,
    };
    try {
      const response: any = await this.ibsAdonisService.rescheduleBooking(
        this.state.estimateDetails.estimateId,
        obj
      );
      if (response?.IsSuccess) {
        Mixpanel.track("Revised Booking", {
          reviseBookinObj: obj,
          estimateDetail: this.state.estimateDetails,
          status: "Booking revised successfully",
        });
      } else {
        Mixpanel.track("Revised Booking", {
          reviseBookinObj: obj,
          estimateDetail: this.state.estimateDetails,
          error: response?.errors[0]?.message || "",
          status: "Booking not revised",
        });
      }
    } catch (err) {
      Mixpanel.track("Revised Booking", {
        reviseBookinObj: obj,
        estimateDetail: this.state.estimateDetails,
        exceptionError: err,
        status: "Booking not revised, exception throws",
      });
      alert(err);
    } finally {
      // Start loader here
      this.setState({
        showLoader: false,
      });
    }
  };

  cancelBooking = async () => {
    // Start loader here
    this.setState({
      showLoader: true,
    });
    const obj = {
      jobId: this.state.estimateDetails.estimateId,
      bookingId: this.state.estimateDetails.jobBookingId,
      expectedArrival: "",
      arrivalNotes: "",
      clearArrivalNotes: true,
    };
    try {
      await this.ibsAdonisService
        .rescheduleBooking(this.state.estimateDetails.estimateId, obj)
        .then((res: any) => {
          if (res?.IsSuccess) {
            this.setState({
              bookingCancel: true,
            });
            Mixpanel.track("Booking Cancelled", {
              cancelBookingObj: obj,
              estimateId: this.state.estimateDetails.estimateId,
              estimateDetail: this.state.estimateDetails,
              status: "Booking Cancelled successfully",
            });
          } else {
            Mixpanel.track("Booking Cancelled Error", {
              cancelBookingObj: obj,
              estimateId: this.state.estimateDetails.estimateId,
              estimateDetail: this.state.estimateDetails,
              error: res?.errors[0]?.message || "Error on cancel booking",
              status: "Booking not cancelled",
            });
          }
        });

      await this.deleteAndUpdateBookingTask();

      this.reloadEstimate();
      this.getAppointments();
      this.getPredictedWorkTime();
    } catch (err) {
      Mixpanel.track("Booking Cancelled Error", {
        cancelBookingObj: obj,
        estimateId: this.state.estimateDetails.estimateId,
        estimateDetail: this.state.estimateDetails,
        exceptionError: err,
        status: "Booking not cancelled, throws error",
      });
    } finally {
      // Start loader here
      this.setState({
        showLoader: false,
      });
    }
  };

  async deleteAndUpdateBookingTask() {
    await deleteBookingTask(this.state.estimateDetails.estimateId);
  }

  async getSMSTemplate() {
    try {
      const SMSTemplates = await this.ibsAdonisService.textMessageSuggestions(
        this.state.estimateDetails.estimateId
      );
      if (SMSTemplates) {
        return (
          SMSTemplates?.find((sms) => sms.id === this.defaultSMS)?.message || ""
        );
      }
    } catch (error) {
      console.error("🚀 ~ Booking ~ getSMSTemplate ~ error:", error);
      return "";
    }
  }

  closeCancelDialog = (data: any) => {
    this.setState({ showConfirmationOfCancelBooking: false });
  };

  cancelBookingAndCloseDialog = async (reason: string) => {
    this.setState({
      showConfirmationOfCancelBooking: false,
    });
    this.setState({
      canceledReason: reason,
    });

    await this.cancelBooking();
    if (this.state.bookingCancel) {
      const message =
        "This estimate was canceled by customer the reason that he mentioned is: " +
        reason;
      await this.sendNotification({
        isCancel: true,
        reason: message,
        title: "Estimate Canceled",
      });
      this.setState({
        bookingCancel: false,
      });
    }
  };

  reviseBookingAndCloseDialog = async () => {
    this.setState({ showConfirmationOfCancelBooking: false });
    this.setState({ isRevised: true });
  };

  handleConfirm = () => {
    // If loader is active, do nothing
    if (this?.state?.showLoader) return;

    // Check if the booking is revised
    if (this?.state?.isRevised) {
      // Show confirmation if revised
      this.setState({ showConfirmation: true });
    } else {
      // Otherwise, save the booking
      this.saveBooking();
    }
  };

  render() {
    const app = this.state.allAppointments.filter((x: any) =>
      x.dueDate
        .toLocaleString()
        .includes(
          moment(this.state.estimateDetails?.expectedArrival).format(
            "YYYY-MM-DD"
          )
        )
    )[0];

    // When Booking will complete it will show booking confirmation screen
    if (this.props?.isBookingDetailCompleted) {
      return (
        <BookingConfirmed
          onClick={() => this.props?.handleDashboardSelectedTab(screens.home)}
          onCountdownComplete={() => {
            if (this?.props?.handleBookingCompleted) {
              this?.props?.handleBookingCompleted(false);
            }
          }}
        />
      );
    }

    if (app) {
      this.selectedAppointment = app;
    }
    // Job is completed
    if (
      this.state.estimateDetails?.expectedPickup &&
      this.state.estimateDetails.isCompleted
    ) {
      return <PickUp estimateDetails={this.state.estimateDetails}></PickUp>;
    }

    if (this.state.isBooked && !this.state.isRevised) {
      return (
        <div className="stepper-control">
          {this.state.bookingCancel ? (
            <Message
              success
              header=""
              content={"Your booking has been canceled"}
            />
          ) : undefined}
          <DisplayBooking
            estimateDetails={this.state.estimateDetails}
            appointment={app}
          ></DisplayBooking>

          {this.state.isVehicleOnSite ? (
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
              <Button
                colorScheme={"red"}
                variant={"outline"}
                as={GridItem}
                onClick={async () => {
                  if (!this.state.showLoader) {
                    this.setState({ showConfirmationOfCancelBooking: true });
                  }
                }}
                disabled={this.state.showLoader}
              >
                Cancel Booking
                {this.state.showLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </Button>
              <Button
                as={GridItem}
                backgroundColor={"#2a4365"}
                color={"white"}
                onClick={() => {
                  if (!this.state.showLoader) {
                    this.setState({ isRevised: true });
                  }
                }}
                disabled={this.state.showLoader}
                _hover={{ backgroundColor: "#2a4365" }}
              >
                Revise Booking
                {this.state.showLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </Button>
            </Grid>
          ) : undefined}

          {this.state.showConfirmationOfCancelBooking ? (
            <CancelBooking
              title={"Cancel Booking"}
              closeDialog={this.closeCancelDialog}
              reviseBooking={this.reviseBookingAndCloseDialog}
              cancelEstimateBooking={this.cancelBookingAndCloseDialog}
            ></CancelBooking>
          ) : undefined}
        </div>
      );
    } else {
      return (
        <div>
          {this.state.isRevised ? (
            <Message
              success
              header=""
              content={
                "You are revising your booking which is for " +
                moment(this.state.estimateDetails?.expectedArrival).format(
                  "ddd, DD/MM/YY hh:mm a"
                )
              }
            />
          ) : undefined}
          {!this.state.showLoader &&
            this.state.appointments.filter((x: any) => x.budget > 0).length ===
              0 && (
              <Message
                error
                header=""
                content="No appointments available for now"
              />
            )}

          {!this.state.bookingSuccessful && this.state.bookingMessage && (
            <Message error header="" content={this.state.bookingMessage} />
          )}
          {this.state.bookingDateError ? (
            <Alert
              borderRadius={4}
              mt={2}
              status="error"
              variant="subtle"
              alignItems={"start"}
              textAlign={"left"}
            >
              <AlertIcon />
              {this.state.bookingDateError}
            </Alert>
          ) : undefined}
          <br></br>

          <BookingCalendar
            estimateDetails={this.state.estimateDetails}
            ibsService={this.iBodyShopService}
            availableAppointments={this.state.appointments}
            onDateSelected={(date: Moment) => {
              if (!this?.state?.showLoader) {
                this.setState({
                  bookingSlot: null,
                  bookingDateError: "",
                  slots: [],
                });
                this.onDateSelected(date);
              }
            }}
            selectedDate={this.state.bookingDate}
            bookingAllowance={this.state.bookingAllowance}
            customQADetails={this.state.customQADetails}
            slots={this.state.slots}
            onSlotPicked={this.onSlotPicked}
            isSelected={this.state.bookingSlot}
            handleConfirm={this?.handleConfirm}
            showLoader={this?.state?.showLoader}
          />
          <Grid
            className="stepper-control"
            templateColumns="repeat(2, 1fr)"
            gap={4}
          >
            {this.state.showConfirmation ? (
              <MessageDialog
                buttons={
                  <Grid templateColumns="repeat(2, 1fr)" gap={4} marginX={2}>
                    <Button
                      colorScheme={"red"}
                      as={GridItem}
                      w="100%%"
                      onClick={() => {
                        this.setState({ showConfirmation: false });
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme={"gray"}
                      as={GridItem}
                      w="100%%"
                      onClick={async () => {
                        if (!this.state.showLoader) {
                          this.setState({ showConfirmation: false });
                          await this.reviseBooking();
                          this.saveBooking(true);
                        }
                      }}
                    >
                      Revise Booking
                    </Button>
                  </Grid>
                }
                closeCallback={() => this.setState({ showConfirmation: false })}
                messageText={
                  "Are you sure you want to revise booking? Your current booking will be canceled"
                }
                title={"Revise Booking"}
              />
            ) : undefined}
          </Grid>
        </div>
      );
    }
  }
}
